// extracted by mini-css-extract-plugin
export var logbook = "styles-module--logbook--NPwIW";
export var content = "styles-module--content--IIDnO";
export var image = "styles-module--image--q7HKQ";
export var text = "styles-module--text--tyTNc";
export var title = "styles-module--title--6KM65";
export var button = "styles-module--button--9gRi-";
export var description = "styles-module--description--LJvLc";